import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideStore, provideState } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routerReducer } from '@ngrx/router-store';
import { provideEffects } from '@ngrx/effects';
import { LandingEffects } from './pages/landing/state/landing.effects';
import { landingFeatureKey, landingReducer } from './pages/landing/state/landing.reducer';
import { locationFeatureKey, locationReducer} from './state/location/location.reducer';
import {LocationEffects} from './state/location/location.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideStore({ router: routerReducer }),
    provideState(landingFeatureKey, landingReducer),
    provideState(locationFeatureKey, locationReducer),
    provideStoreDevtools({ maxAge: 25 }),
    provideEffects([LandingEffects, LocationEffects]),
    provideRouter(routes), provideAnimations(),
    provideHttpClient(withFetch()),
  ],
};
